import { createPortal } from 'react-dom';
import { useToastStore } from '../store/toast';
import styles from './ui.module.css';

export function ToastHost() {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className={styles.toastHost} role="region" aria-label="Notifications">
      <div aria-live="polite" aria-atomic="false">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={[
              styles.toast,
              toast.tone === 'good' ? styles.toastGood : '',
              toast.tone === 'bad' ? styles.toastBad : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <span className={styles.toastMessage}>{toast.message}</span>
            {toast.action ? (
              <button
                type="button"
                className={styles.toastAction}
                onClick={() => {
                  toast.action?.run();
                  dismiss(toast.id);
                }}
              >
                {toast.action.label}
              </button>
            ) : (
              <button type="button" className={styles.toastAction} onClick={() => dismiss(toast.id)}>
                Dismiss
              </button>
            )}
          </div>
        ))}
      </div>
    </div>,
    document.body,
  );
}
